function Education() {

  return (

    <section id="education" className="reveal">

      <div className="section-title">
        <h2>Education</h2>
      </div>

      <div className="education-container">

        <div className="education-image">
          <img
            src="/images/college.jpg"
            alt="Vignan University"
          />
        </div>

        <div className="education-info">

          <h3>B.Tech Computer Science & Engineering</h3>

          <p className="edu-specialization">
            Specialization in Artificial Intelligence and Machine Learning
          </p>

          <p className="edu-college">
            Vignan's Foundation for Science, Technology & Research (Deemed to be University)
          </p>

          <p className="edu-description">
            Currently pursuing my undergraduate degree with a focus on Artificial Intelligence,
            Machine Learning, and modern software development. My academic journey combines
            engineering fundamentals with creative exploration in areas like web development,
            digital design, and emerging technologies.
          </p>

          <br />

          <p className="edu-location">
            📍 Vadlamudi, Guntur, Andhra Pradesh, India
          </p>

          <p className="edu-website">
            🌐{" "}
            <a
              href="https://www.vignan.ac.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit University Website
            </a>
          </p>

        </div>

      </div>

    </section>

  );

}

export default Education;